/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.1.5
 */

export type ReportsFindCoordinatesStatus =
  (typeof ReportsFindCoordinatesStatus)[keyof typeof ReportsFindCoordinatesStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesStatus = {
  publishedRRA: 'publishedRRA',
  pendingRRA: 'pendingRRA',
  draft: 'draft',
  published: 'published',
  incorrect: 'incorrect',
} as const;
